import React, { useState, useEffect, useRef, useMemo } from 'react';
import { View } from 'react-native'

import api from "../../../../utils/api"
import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import IcomoonIcon from '../../../../components/IcomoonIcon';
import { Icon } from '../../../../components/Icon';
import { Image } from 'expo-image';
import IconButton from '../../../../components/IconButton';
import Header from '../../../../navigation/Header';
import TabsSelector from '../../../../components/TabsSelector';
import DebtorsSection from './Debtors/DebtorsSections';

import ExpensesSection from './Expenses/ExpensesSection';
import ReportsSection from './Reports/ReportsSection';
import FeesScreen from './Fees/FeesSection';
import PaymentsSection from './Payments/PaymentsSection';
import useActiveAdminCommunity from '../../../../hooks/useActiveAdminCommunity';
import UnitsFeesSection from './Units/UnitsFeesSection';


export default function AdminFeesScreen({ navigation, route }) {
  // const { communityId } = route.params
  const { community, communityId } = useActiveAdminCommunity()

  const [selectedTab, setSelectedTab] = useState("units");

  const feesScreenRef = useRef()
  const paymentsScreenRef = useRef()


  const menuOptions = useMemo(() => {
    let options = []

    if (community.settings?.expenses_enabled){
      options.push({ label: "Balance", value: "reports" })
    }

    options.push(
      { label: "Viviendas", value: "units" },
      { label: "Mantenimiento", value: "mainteinance" },
      { label: "Pagos", value: "payments" },
      { label: "Cuotas", value: "fees" },
    )

    if (community.settings?.expenses_enabled){
      options.push({ label: "Gastos", value: "expenses" })
    }

    options.push({ label: "Mora", value: "debtors" })

    return options
  }, [community])

  // Si el tab activo no está en las opciones (p. ej. al cargar settings), usa el primero.
  useEffect(() => {
    if (menuOptions.length && !menuOptions.some(o => o.value === selectedTab)) {
      setSelectedTab(menuOptions[0].value)
    }
  }, [menuOptions])

  return (
    <View style={tw`flex-1 bg-background`}>
      {/* Header */}
      <Header style={`mb-0 bg-secondary rounded-b-none`}>
        <View style={tw`flex-1`}>

          <View style={tw`row justify-between`}>
            <View style={tw`row`}>
              {/* <Icon name='time' color={tw.color('white')} style={tw``} size={20} /> */}
              <Icon name="navFinanzas" variant="white" size={32} style={tw`mr-1 -ml-2`} />

              <Text style={tw`text-xl font-600 text-white`}>Finanzas</Text>
              {/* <Text style={tw`ml-3 text-xl font-600 text-white`}>{categorizedFees?.last_monthly?.name ?? "Cuota mensual"}</Text> */}
            </View>

            {
              selectedTab === "fees" &&
                <View style={tw`row`}>
                  <IconButton title={"Crear"} color='white' textColor='secondary' style={tw`mr-3`} onPress={() => feesScreenRef.current.setShowCreateFeeModal(true)} />
                </View>
            }

            {
              selectedTab === "payments" &&
                <View style={tw`row`}>
                  <IconButton title={"Buscar"} icon='search' color='white' textColor='secondary' style={tw`mr-3`} onPress={() => paymentsScreenRef.current.setShowPaymentSearchModal(true)} />
                </View>
            }
          </View>

          {/* <TouchableOpacity
            style={tw`mt-8`}
            onPress={() => {
              categorizedFees?.last_monthly && 
                navigation.navigate("Admin.Fees.Detail", {
                  feeId: categorizedFees?.last_monthly.uuid,
                  communityId: route.params.communityId,
                })
            }}
          >
            <Icon name='chevron-right' size={15} color={'white'} style={tw`absolute -right-1 top-3`} />

            <View style={tw`row border-b border-white/30 pb-2 mb-2`}>
              <Text style={tw`text-white font-600 text-5xl leading-[1.1]`}>${categorizedFees?.last_monthly?.pending_amount?.toLocaleString() ?? "0"}</Text>
              <Text style={tw`text-white ml-2`}>por cobrar</Text>
            </View>
            
            <Text style={tw`text-primary`}><Text style={tw`text-lg`}>${categorizedFees?.last_monthly?.charged_amount?.toLocaleString()}</Text> cobrado</Text>

            <View style={tw`row`}>
              <Image source={require('../../../../assets/images/icons/casa.svg')} style={tw`h-5 w-5`} contentFit='contain' />

              <Text style={tw`text-white ml-2`}>{categorizedFees?.last_monthly?.pending_units} pagos restantes</Text>
            </View>
          </TouchableOpacity> */}
        </View>
      </Header>


      <View style={tw``}>
        <TabsSelector
          pills
          selectedValue={selectedTab}
          onChange={value => setSelectedTab(value)}
          options={menuOptions}
        />
      </View>


      {
        selectedTab === "mainteinance" &&
          <FeesScreen communityId={communityId} filter="mainteinance" />
      }

      {
        selectedTab === "fees" &&
          <FeesScreen communityId={communityId} ref={feesScreenRef} filter="other" />
      }

      {
        selectedTab === "units" &&
          <UnitsFeesSection communityId={communityId} />
      }

      {
        selectedTab === "debtors" &&
          <DebtorsSection communityId={communityId} />
      }

      {
        selectedTab === "expenses" &&
          <ExpensesSection communityId={communityId} />
      }

      {
        selectedTab === "payments" &&
          <PaymentsSection communityId={communityId} ref={paymentsScreenRef} />
      }

      {
        selectedTab === "reports" &&
          <ReportsSection communityId={communityId} />
      }

    </View>
  );
}
